module.exports = __webpack_public_path__ + "media/audio45.a37f9d43.mp3";